import { filterParams, formatPics } from '@/common/utils/format'
import { get } from 'lodash-es'
import { i18n, getBDCountry } from '@/common/utils/i18n'
const country = getBDCountry() || 'MX'


export function revert (data = {}) {
  const payment = get(data, 'contractGlobal.authorizationInfo.payment')
  let revertted = {}
  if (payment) {
    revertted = {
      ...payment,
      authorizedPics: formatPics(payment.authorizedPics),
      extraFiles: formatPics(payment.extraFiles),
      pics: formatPics(payment.pics)
    }
  }
  return revertted
}

export function  submitFormat (payment) {
    let sign = get(this, 'signForm.signAuthInfo') || {}
    sign = Object.keys(sign).reduce((target, key) => {
      target[key] = sign[key].map(d => d.key)
      return target
    }, {})
    const json = {
      source: 'contractor',
      queryId: this.$route.params.id,
      contractGlobal: {
        authorizationInfo: {
          sign,
          payment
        }
      }
    }
    console.log(json)
    return {
      params: JSON.stringify(json)
    }
  }

export default {
  revert,
  submitFormat
}
